import { render, staticRenderFns } from "./CommunicationTable.vue?vue&type=template&id=a5618b12&scoped=true&"
import script from "./CommunicationTable.vue?vue&type=script&lang=js&"
export * from "./CommunicationTable.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationTable.vue?vue&type=style&index=0&id=a5618b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5618b12",
  null
  
)

export default component.exports